import Big from 'big.js'
import equal from 'fast-deep-equal'
import { get } from 'svelte/store'

import { messages } from '$lib/messages'
import { apiGetJson, apiPostJson } from '$lib/proxy/apiProxy'
import { debounced, SemaphoreKey, waitDebouncedFinish } from '$lib/semaphores'

import { makeItemWithId } from './factories'
import { item_store as store } from './item'
import type { Item, ItemProps, ServerItem } from './types'

const cons_log_file = '#1182 - item/manager - '

export async function getItem(id: string | null) {
	console.log(cons_log_file + 'getItem', id)

	if (!id) {
		store.set(makeItemWithId())
		return get(store)
	}
	if (id === get(store).id) 
		return get(store)


	const jsonResponse = await apiGetJson('/items/get', { id })
	if (jsonResponse?.error) {
		return null
	}

	// console.log(cons_log_file + 'getItem', jsonResponse)
	const data = parseServerItem(jsonResponse.item)
	store.set(data)
	return data
}

export function resetItem(data?: Item | null) {
	if (data) {
		store.set(data)
	} else {
		store.set(makeItemWithId())
	}
}

export function setItem(props: ItemProps, skipSave: boolean=false) {

	const oldData = get(store)
	store.update((existing) => ({
		...existing,
		...props
	}))
    
	if (skipSave) return

	const newData = get(store)
	if (equal(cleanData(oldData), cleanData(newData))) {
		return
	}

	//============================================
	// seve only if the id != null and != ''
	if (newData.id && newData.id != '' ){
		debounced(SemaphoreKey.Item, saveData)
	}
}

export async function forceSaveItem() {
	return await debounced(SemaphoreKey.Item, saveData, 0)
}


//=====================================================
// ItemTaxes
export const getItemTaxes = async (itemId: string) => {
	if (!itemId) {
		console.error('getItemTaxes received itemId===null')
		return
	}
	const jsonData = await apiGetJson(`/item/${itemId}/taxes`)
	if (!jsonData || jsonData?.error) {
		return []
	}
	return jsonData.taxes
}



//=====================================================
// #region Internal Functions
async function saveData() {
	console.log(cons_log_file + 'save')

	const newData = cleanData(get(store))

	await waitDebouncedFinish(SemaphoreKey.Tax)
	
	const jsonData = await apiPostJson('/items/upsert', { item: newData })
	if (jsonData?.error) {
		messages.error(`Could not save item: ${jsonData.error.message}`)
		return
	}
}


function cleanData(data: Item): Item {
	return {
		...data,
		name: data.name.trim(),
		details: data.details.trim(),
		sku: data.sku.trim()
	}
}
export function parseServerItem(data: ServerItem): Item {
	return { ...data, cost: Big(data.cost), price: Big(data.price) }
}

// #endregion